export default {
  name: 'SchemaItems',
  props: {
    schemas: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleFixedChange(item) {
      const newItem = { ...item,
        isFixed: !item.isFixed
      };
      this.$emit('save', newItem);
    },

    handleDelete(item) {
      this.$emit('del', item);
    }

  }
};